const ROUTES = {
  HOME: '/',
  NOT_FOUND: '*',
  FORM_PAGE: '/form',
  SUCCESS: '/success',
};
export default ROUTES;
